import colors from 'globals/colors'
import styled from 'styled-components'

export const MFADescription = styled.div`
  line-height: 22px;
  font-size: 16px;
  margin-bottom: 19px;
`

export const MFAInputWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  
  & > .ant-input-wrapper {
    padding: 0;
    flex-basis: auto;
  }
  
  & span.ant-input-affix-wrapper {
    width: 210px;
    padding: 13px 25px;
    display: inline-block;
    
    &::before {
      display: none;
    }

    & input {
      width: 120%;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 20px;
      text-overflow: initial;
      background: transparent;

      &::placeholder {
        width: 210px;
        font-size: 11px;
      letter-spacing: 15px;
        color: ${colors.lightGrey};
        position: relative;
        top: -2px;
      }
    }
    
    & .ant-input-suffix {
      display: none;
    }
  }
`

export const ResendLink = styled.a`
  font-size: 13px;
  margin-left: 15px;
`
